import React, {useEffect, useState} from 'react';
import '../../../Modals/ChestPurchaseModal/ChestPurchaseModal.css';
import './AdminReferalFilterModal.css';
import PageButton from '../../../elements/PageButton/PageButton';
import {API_BASE} from '../../../../utils/apiConfig';
import {COINS_COLOR} from '../../../../styles/constants';

const PAGE_ID = 'AdminReferalFilterModal';

/**
 * Выбор источников рефералов для фильтра списка пользователей: все партнеры и
 * игроки, пригласившие хотя бы одного друга (см. /api/admin/referal-sources).
 * Отмеченные источники применяются к списку кнопкой «Применить», «Скрыть»
 * закрывает модалку, ничего не меняя.
 *
 * Оформление — как у модалки кристаллов за рейтинг (общие классы
 * chest-purchase-*), только подсветка по цвету монет. ModalWindow здесь не
 * годится: то окно светлое и предназначено для игровых партий
 */
function AdminReferalFilterModal({selectedIds, onApply, onClose}) {
  const [visible, setVisible] = useState(false);
  const [sources, setSources] = useState([]);
  const [checkedIds, setCheckedIds] = useState(() => new Set(selectedIds || []));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    const fetchSources = async () => {
      try {
        const res = await fetch(`${API_BASE}/admin/referal-sources`, {credentials: 'include'});
        if (!res.ok) throw new Error('Failed to fetch referal sources');
        const data = await res.json();
        setSources(data.sources || []);
      } catch (e) {
        console.error('Fetch referal sources error', e);
        setError('Не удалось загрузить список');
      } finally {
        setLoading(false);
      }
    };
    fetchSources();
  }, []);

  const close = (onClosed) => {
    setVisible(false);
    setTimeout(onClosed, 300);
  };

  const handleClose = () => close(() => onClose?.());
  const handleApply = () => close(() => onApply?.([...checkedIds]));

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  const toggleId = (id) => {
    setCheckedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <div
      className={`chest-purchase-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role={'dialog'}
      aria-modal={'true'}
      style={{'--chest-shadow-color': COINS_COLOR}}
    >
      <div
        className={`chest-purchase-modal admin-referal-filter-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}
      >
        <div className={'chest-purchase-content'}>
          <h2 className={'admin-referal-filter-modal_title'}>Фильтр рефералов</h2>

          {loading && <p className={'admin-referal-filter-modal_status'}>Загрузка...</p>}
          {error && <p className={'admin-referal-filter-modal_status'}>{error}</p>}
          {!loading && !error && sources.length === 0 && (
            <p className={'admin-referal-filter-modal_status'}>Пока никто не привел рефералов</p>
          )}

          {!loading && !error && sources.length > 0 && (
            <div className={'admin-referal-filter-modal_list'}>
              {sources.map((source) => {
                const totalCount = source.partnerReferralsCount + source.friendReferralsCount;
                return (
                  <label key={source.id} className={'admin-referal-filter-modal_row'}>
                    <input
                      type={'checkbox'}
                      className={'admin-referal-filter-modal_checkbox'}
                      checked={checkedIds.has(source.id)}
                      onChange={() => toggleId(source.id)}
                    />
                    <span className={'admin-referal-filter-modal_name'}>{source.name}</span>
                    {source.isPartner && (
                      <span className={'admin-referal-filter-modal_tag text-crystals'}>партнер</span>
                    )}
                    <span className={'admin-referal-filter-modal_count'}>{totalCount}</span>
                  </label>
                );
              })}
            </div>
          )}

          <div className={'main-menu-buttons chest-purchase-buttons'}>
            <PageButton
              className={'chest-purchase-buy-button'}
              onClick={handleApply}
              pageId={PAGE_ID}
              buttonId={'apply'}
            >
              Применить
            </PageButton>

            <PageButton
              className={'main-menu-button_secondary'}
              onClick={handleClose}
              pageId={PAGE_ID}
              buttonId={'hide'}
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminReferalFilterModal;
